import React from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Header } from 'formlabs-web-components/Type';
import { Picture } from 'formlabs-web-components/Media';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import quoteIcon from '../../../../public/icons/quote_icon.svg';

import './Quote.module.css';
import { withTranslation } from 'react-i18next';

const Quote = ({ quote, name, title, t }) => {
  return (
    <div styleName="quote" className="quote">
      <Grid direction="x" primaryAlignment="align-center">
        <Cell smallSize={16} mediumSize={18}>
          <div styleName="slide-alignment">
            <Picture largeImage={quoteIcon} width="32" alt="" />
            <Header level={4} displayAs={4} weight={400}>
              {quote}
            </Header>
            <hr />
            <p>
              <strong>{name}</strong>
              <br />
              <span>{title}</span>
            </p>
          </div>
        </Cell>
      </Grid>
    </div>
  );
};

export default DisplayComponent(withTranslation()(Quote));
